import React, { PureComponent } from 'react';
import Radium from 'radium';
import { UTLabel } from '@widergy/energy-ui';

import { appConfig } from 'config/customization';
import { message } from 'utils/stringUtils';
import { UTILITIES } from 'constants/utilitiesMappers';
import { ROUTES } from 'constants/routes';

import { gaTrackPageView } from '../../../../../services/AnalyticsService';

import styles from './styles';
import EdenContent from './components/EdenContent';
import OthersContent from './components/OthersContent';

const Components = {
  [UTILITIES.eden]: EdenContent,
  [UTILITIES.edelap]: OthersContent,
  [UTILITIES.edes]: OthersContent,
  [UTILITIES.ejesa]: OthersContent,
  [UTILITIES.edet]: OthersContent,
  [UTILITIES.utilityco]: OthersContent
};

const Component = Components[appConfig.mappers];

const ChangeDueDate = props => <Component {...props} />;

class ChangeDueDateWrapper extends PureComponent {
  componentDidMount() {
    gaTrackPageView(ROUTES.PUBLIC_CHANGE_DUE_DATE);
  }

  render() {
    return (
      <div style={styles.container}>
        <UTLabel bold large>
          {message('ChangeDueDate:topTitle')}
        </UTLabel>
        <ChangeDueDate {...this.props} />
      </div>
    );
  }
}

export default Radium(ChangeDueDateWrapper);
